import { IImage, IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';
import { Component, Input } from 'angular-ts-decorators';
import { customPaging } from './utils/custom-paging';

import template from './hero-customizer-v2.image-slider.component.html';

@Component({
  selector: 'heroCustomizerV2ImageSlider',
  template,
})
export class HeroCustomizerV2ImageSliderComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public group?: IProductWithAttributes;
  @Input() public lifestyleImages?: string[];

  public images?: IImage[];

  public ngOnChanges() {
    this.images = undefined;
    if (this.group) {
      this.images = this.group.images
        .filter((x: IImage, index: number) => index < 4)
        .filter((x: IImage) => Boolean(x.url))
        .concat((this.lifestyleImages || []).map((x: string) => ({ url: x })));
    }
  }

  public customPaging(slick: any, index: number): string {
    return customPaging(this.images, index, this.group.productName);
  }

  public get isSingleImage(): boolean {
    return this.images && this.images.length === 1;
  }
}
